import { v4 as uuid } from 'uuid';
import { isBooleanTrue, isListNotEmpty, isNumberNotEmpty, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import PaymentDetails from "./PaymentDetails";

class OrderPayment {
    id = uuid();
    due = 0.0; // amount due
    amount = 0.0; // amount paid
    method = "OTHER"; // enum PaymentMethods
    details = new PaymentDetails(null).toDto();
    status = "PENDING"; // enum PaymentStatuses, current status
    statusHistory = []; // list of StatusHistory, historical changes to payment status
    transactionId = null;
    voucherId = null;
    storeCreditId = null;
    isPaid = false;
    notes = []; // list of OrderNote, notes about the payment

    constructor(payment) {
        if (isObjectNotEmpty(payment)) {
            if (isStringNotEmpty(payment.id)) { this.id = payment.id; }
            if (isNumberNotEmpty(payment.due)) { this.due = payment.due; }
            if (isNumberNotEmpty(payment.amount)) { this.amount = payment.amount; }
            if (isStringNotEmpty(payment.method)) { this.method = payment.method; }
            if (isObjectNotEmpty(payment.details)) { this.details = payment.details; }
            if (isStringNotEmpty(payment.status)) { this.status = payment.status; }
            if (isListNotEmpty(payment.statusHistory)) { this.statusHistory = payment.statusHistory; }
            if (isStringNotEmpty(payment.transactionId)) { this.transactionId = payment.transactionId; }
            if (isStringNotEmpty(payment.voucherId)) { this.voucherId = payment.voucherId; }
            if (isStringNotEmpty(payment.storeCreditId)) { this.storeCreditId = payment.storeCreditId; }
            if (isBooleanTrue(payment.isPaid)) { this.isPaid = true; }
            if (isListNotEmpty(payment.notes)) { this.notes = payment.notes; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            due: this.due,
            amount: this.amount,
            method: this.method,
            details: this.details,
            status: this.status,
            statusHistory: this.statusHistory,
            transactionId: this.transactionId,
            voucherId: this.voucherId,
            storeCreditId: this.storeCreditId,
            isPaid: this.isPaid,
            notes: this.notes,
        };
    }
};

export default OrderPayment;